/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-fa22eda7.mjs';
import { defineComponent, inject, h, watch, onMounted, onUnmounted, createVNode } from 'vue';
import { ANCHOR_SHARP_REGEXP } from './utils.mjs';
import props from './anchor-item-props.mjs';
import { usePrefixClass, useCommonClassName } from '../hooks/useConfig.mjs';
import { AnchorInjectionKey } from './constants.mjs';
import { i as isFunction_1 } from '../_chunks/dep-1f286011.mjs';
import { i as isString_1 } from '../_chunks/dep-b390ff23.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-4371fb57.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-31d34e52.mjs';
import '../_chunks/dep-67e8723b.mjs';
import '../_chunks/dep-0bf03d55.mjs';
import '../_chunks/dep-5b5daf08.mjs';
import '../_chunks/dep-95049222.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../_chunks/dep-ac19a2b6.mjs';
import '../_chunks/dep-90d97bcb.mjs';
import '../_chunks/dep-c8679a16.mjs';
import '../_chunks/dep-939a74d6.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-e9ff4ce8.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-e4f65bc4.mjs';
import '../_chunks/dep-45572c49.mjs';
import '../_chunks/dep-1aa18f5f.mjs';
import '../_chunks/dep-e09a06d8.mjs';
import '../_chunks/dep-07f3660d.mjs';
import '../_chunks/dep-0d3220b0.mjs';
import '../_chunks/dep-895678a0.mjs';
import '../_chunks/dep-b2bdc7b9.mjs';
import '../_chunks/dep-0f45a6e0.mjs';
import '../_chunks/dep-35a4fd8d.mjs';
import '../_chunks/dep-54378e60.mjs';
import '../_chunks/dep-25b8bf4b.mjs';
import '../_chunks/dep-c40264c0.mjs';
import '../_chunks/dep-9d499243.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-0927ceb7.mjs';
import '../_chunks/dep-f0bd05df.mjs';
import '../config-provider/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var localProps = _objectSpread(_objectSpread({}, props), {}, {
  href: {
    type: String,
    required: true,
    validator: function validator(v) {
      return ANCHOR_SHARP_REGEXP.test(v);
    }
  }
});
var _AnchorItem = defineComponent({
  name: "TAnchorItem",
  inject: {
    tAnchor: {
      "default": void 0
    }
  },
  props: localProps,
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var anchor = inject(AnchorInjectionKey, void 0);
    var CLASSNAME_PREFIX = usePrefixClass("anchor__item");
    var _useCommonClassName = useCommonClassName(),
      STATUS = _useCommonClassName.STATUS;
    var register = function register() {
      anchor.registerLink(props2.href);
    };
    var unregister = function unregister() {
      var href = props2.href;
      if (!href) return;
      anchor.unregisterLink(href);
    };
    var handleClick = function handleClick(e) {
      var href = props2.href,
        title = props2.title;
      anchor.handleScrollTo(href);
      anchor.handleLinkClick({
        href: href,
        title: isString_1(title) ? title : void 0,
        e: e
      });
    };
    var renderTitle = function renderTitle() {
      var title = props2.title;
      var titleSlot = slots.title;
      var titleVal;
      if (isString_1(title)) {
        titleVal = title;
      } else if (isFunction_1(title)) {
        titleVal = title(h);
      } else if (titleSlot) {
        titleVal = titleSlot(null);
      }
      return titleVal;
    };
    watch(function () {
      return props2.href;
    }, function () {
      unregister();
      register();
    }, {
      immediate: true
    });
    onMounted(function () {
      register();
    });
    onUnmounted(function () {
      unregister();
    });
    return function () {
      var _wrapperClass;
      var href = props2.href,
        target = props2.target;
      var children = slots["default"],
        titleSlot = slots.title;
      var title = renderTitle();
      var titleAttr = isString_1(title) ? title : null;
      var active = anchor.active === href;
      var wrapperClass = (_wrapperClass = {}, _defineProperty(_wrapperClass, CLASSNAME_PREFIX.value, true), _defineProperty(_wrapperClass, STATUS.value.active, active), _wrapperClass);
      var titleClass = _defineProperty({}, "".concat(CLASSNAME_PREFIX.value, "-link"), true);
      return createVNode("div", {
        "class": wrapperClass
      }, [createVNode("a", {
        "href": href,
        "title": titleAttr,
        "class": titleClass,
        "target": target,
        "onClick": handleClick
      }, [titleSlot ? titleSlot(null) : title]), children && children(null)]);
    };
  }
});

export { _AnchorItem as default };
//# sourceMappingURL=anchor-item.mjs.map
